import { render, staticRenderFns } from "./RedmineIssueForm.vue?vue&type=template&id=adfff35a&scoped=true"
import script from "./RedmineIssueForm.vue?vue&type=script&lang=js"
export * from "./RedmineIssueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfff35a",
  null
  
)

export default component.exports